import { render, staticRenderFns } from "./AcceptSetting.vue?vue&type=template&id=c6b1e98e&scoped=true&"
import script from "./AcceptSetting.vue?vue&type=script&lang=js&"
export * from "./AcceptSetting.vue?vue&type=script&lang=js&"
import style0 from "./AcceptSetting.vue?vue&type=style&index=0&id=c6b1e98e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b1e98e",
  null
  
)

export default component.exports